import { useTranslatedTag } from "@next-platform/client-common-core";
import { useMemo } from "react";

export interface ITranslatedTag {
  original: string;
  displayName: string;
}

/**
 * Hook to translate multiple tags
 * @param tags - Array of tags to translate
 * @returns Array of objects with original tag and translated displayName
 */
export const useTranslatedTags = (tags: readonly string[] = []): ITranslatedTag[] => {
  const { getTranslatedTag } = useTranslatedTag();

  return useMemo(
    () =>
      tags?.map((tag) => ({
        original: tag,
        displayName: getTranslatedTag(tag) || tag,
      })) || [],
    [tags, getTranslatedTag],
  );
};
